"use client";
import { DEFAULT_THEME } from "../default-theme.mjs";
import { mergeMantineTheme } from "../merge-mantine-theme/merge-mantine-theme.mjs";
import { createContext, use, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/core/MantineProvider/MantineThemeProvider/MantineThemeProvider.tsx
const MantineThemeContext = createContext(null);
const useSafeMantineTheme = () => use(MantineThemeContext) || DEFAULT_THEME;
function useMantineTheme() {
	const ctx = use(MantineThemeContext);
	if (!ctx) throw new Error("@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app");
	return ctx;
}
function MantineThemeProvider({ theme, children, inherit = true }) {
	const parentTheme = useSafeMantineTheme();
	const mergedTheme = useMemo(() => mergeMantineTheme(inherit ? parentTheme : DEFAULT_THEME, theme), [
		theme,
		parentTheme,
		inherit
	]);
	return /* @__PURE__ */ jsx(MantineThemeContext, {
		value: mergedTheme,
		children
	});
}
MantineThemeProvider.displayName = "@mantine/core/MantineThemeProvider";
//#endregion
export { MantineThemeContext, MantineThemeProvider, useMantineTheme, useSafeMantineTheme };

//# sourceMappingURL=MantineThemeProvider.mjs.map